import { ThemeCss } from "gatsby-interface"

export const detailsRowCss: ThemeCss = _theme => ({
  alignItems: `center`,
  display: `flex`,
})

export const lockIcon: ThemeCss = theme => ({
  color: theme.colors.green[80],
  position: `absolute`,
  transform: `translate(-150%, -10%)`,
  background: theme.colors.green[10],
  padding: theme.space[2],
  borderRadius: theme.radii[6],
  width: theme.space[7],
  height: theme.space[7],
})
